import { OrderStopType } from "@/constants/order";

export enum RouteStopStatus {
  notStarted = "new",
  inRoute = "in-route",
  waitingForLoading = "wait-load-unload",
  waitingForVerification = "wait-verify",
  waitingForGoodToGo = "wait-go",
  completed = "completed",
}

export const RouteStopStatusMap = [
  {
    id: RouteStopStatus.notStarted,
    name: "Not started",
  },
  {
    id: RouteStopStatus.inRoute,
    name: "On route to",
  },
  {
    id: RouteStopStatus.waitingForLoading,
    name: "Waiting for loading",
    type: OrderStopType.pickup,
  },
  {
    id: RouteStopStatus.waitingForLoading,
    name: "Waiting for unloading",
    type: OrderStopType.delivery,
  },
  {
    id: RouteStopStatus.waitingForVerification,
    name: "Waiting for verification",
  },
  {
    id: RouteStopStatus.waitingForGoodToGo,
    name: "Waiting for good to go",
  },
  {
    id: RouteStopStatus.completed,
    name: "Completed",
  },
];

export enum LoadingRouteStatus {
  loading = `${RouteStopStatus.waitingForLoading}-${OrderStopType.pickup}`,
  unloading = `${RouteStopStatus.waitingForLoading}-${OrderStopType.delivery}`,
}

export const NotStartedRouteStopStatus = [RouteStopStatus.notStarted, RouteStopStatus.inRoute];

export const RouteStopStatusOptions = RouteStopStatusMap.map((item) => {
  if (item.id === RouteStopStatus.waitingForLoading && item.type === OrderStopType.pickup) {
    return {
      ...item,
      id: LoadingRouteStatus.loading,
    };
  }

  if (item.id === RouteStopStatus.waitingForLoading && item.type === OrderStopType.delivery) {
    return {
      ...item,
      id: LoadingRouteStatus.unloading,
    };
  }

  return item;
});

export enum TravelOrderStatus {
  active = "active",
  dryRun = "dry-run",
  waitingForDryRun = "wait-dry-run",
  noDryRun = "no-dry-run",
  completed = "completed",
  cancelled = "cancelled",
}

export const TravelOrderStatusMap = [
  {
    id: TravelOrderStatus.active,
    name: "Active",
    forEdit: true,
  },
  {
    id: TravelOrderStatus.dryRun,
    name: "Dry run",
    forCancellation: true,
    forEdit: true,
  },
  {
    id: TravelOrderStatus.waitingForDryRun,
    name: "Waiting for dry run",
    forCancellation: true,
    forEdit: true,
  },
  {
    id: TravelOrderStatus.noDryRun,
    name: "No dry run",
    forEdit: true,
    forCancellation: true,
  },
  {
    id: TravelOrderStatus.completed,
    name: "Completed",
  },
  {
    id: TravelOrderStatus.cancelled,
    name: "Cancelled",
    forCancellation: true,
    forEdit: true,
  },
];

export const TravelOrderCancellationStatusMap = TravelOrderStatusMap.filter((s) => s?.forCancellation);
export const TravelOrderEditStatusMap = TravelOrderStatusMap.filter((s) => s?.forEdit);
export const TravelOrderCancelStatuses: TravelOrderStatus[] = TravelOrderCancellationStatusMap.map((item) => item.id);
export enum RouteStatus {
  notStarted = "new",
  inProgress = "in-progress",
  completed = "completed",
  planned = "planned",
  cancelled = "cancelled",
}

export const ActiveRouteStatuses = [RouteStatus.inProgress, RouteStatus.notStarted];

export const FinishRouteStatuses = [RouteStatus.cancelled, RouteStatus.completed];

export const RouteStatusMap = [
  {
    id: RouteStatus.notStarted,
    name: "New",
  },
  {
    id: RouteStatus.inProgress,
    name: "In progress",
  },
  {
    id: RouteStatus.completed,
    name: "Completed",
  },
  {
    id: RouteStatus.planned,
    name: "Planned",
  },
];

export enum TripStatus {
  notStarted = "new",
  inProgress = "in-progress",
  completed = "completed",
}

export const TripStatusMap = [
  {
    id: TripStatus.notStarted,
    name: "New",
  },
  {
    id: TripStatus.inProgress,
    name: "In progress",
  },
  {
    id: TripStatus.completed,
    name: "Completed",
  },
];

export const IntervalOptions = [
  { id: 30, name: "Every 30 minutes" },
  { id: 60, name: "Every 1 hour" },
  { id: 90, name: "Every 1 hour 30 minutes" },
  { id: 120, name: "Every 2 hours" },
  { id: 150, name: "Every 2 hours 30 minutes" },
  { id: 180, name: "Every 3 hours" },
  { id: 210, name: "Every 3 hours 30 minutes" },
  { id: 240, name: "Every 4 hours" },
  { id: 270, name: "Every 4 hours 30 minutes" },
  { id: 300, name: "Every 5 hours" },
  { id: 330, name: "Every 5 hours 30 minutes" },
  { id: 360, name: "Every 6 hours" },
  { id: null, name: "Never" },
];

export enum TripDateField {
  NextStopSoonest = "nextStopSoonestDate",
  NextStopLatest = "nextStopLatestDate",
  ETASoonest = "etaSoonestDate",
  ETALatest = "etaLatestDate",
  LastCheckCallSoonest = "lastCheckCallSoonestDate",
  LastCheckCallLatest = "lastCheckCallLatestDate",
  CheckCallTimersSoonest = "checkCallTimersSoonestDate",
  CheckCallTimerLatest = "checkCallTimerLatestDate",
  UpdateTimerSoonest = "updateTimerSoonestDate",
  UpdateTimerLatest = "updateTimerLatestDate",
  AllTimersSoonest = "allTimersSoonestDate",
  AllTimersLatest = "allTimersLatestDate",
}

export enum RouteRedispatchState {
  normal = "normal",
  needed = "needed",
  notConfirmed = "not-confirmed",
}

export const RedispatchStateMap = [
  {
    id: RouteRedispatchState.normal,
    name: "Confirmed",
  },
  {
    id: RouteRedispatchState.needed,
    name: "Redispatch needed",
  },
  {
    id: RouteRedispatchState.notConfirmed,
    name: "Redispatch not confirmed",
  },
];

export enum RouteStopState {
  normal = "normal",
  updated = "updated",
  deleted = "deleted",
}

export enum RouteStopFileType {
  bol = "bol",
  pod = "pod",
  other = "other",
}
